// extracted by mini-css-extract-plugin
export var adjacentSlide = "_s6-9";
export var arrowButtonContainer = "_s6-5";
export var arrowButtonIcon = "_s6-6";
export var carouselArrowButton = "_s6-2";
export var carouselElementContainer = "_s6-1";
export var currentSlide = "_s6-8";
export var left = "_s6-3";
export var otherSlide = "_s6-a";
export var productCarouselContainer = "_s6-0";
export var right = "_s6-4";
export var sliderOverflow = "_s6-7";